import { render, staticRenderFns } from "./guiaDespachoExportacion.vue?vue&type=template&id=24f952aa"
import script from "./guiaDespachoExportacion.vue?vue&type=script&lang=js"
export * from "./guiaDespachoExportacion.vue?vue&type=script&lang=js"
import style0 from "./guiaDespachoExportacion.vue?vue&type=style&index=0&id=24f952aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports